export enum SCOPES {
    IN_SCOPE = 'in_scope',
    OUT_SCOPE = 'out_scope'
}

export const SCOPES_TITLE = {
    [SCOPES.IN_SCOPE]: 'In scope',
    [SCOPES.OUT_SCOPE]: 'Out of scope'
};

export const SCOPES_COLOR = {
    [SCOPES.IN_SCOPE]: 'bg-sf-positive-500',
    [SCOPES.OUT_SCOPE]: 'bg-sf-negative-500'
};

export enum AD_ENTITY_TYPES {
    USER = 1,
    GROUP = 2,
    OU = 3
}

export type ScopeEntity = {
    guid: string;
    display_name: string;
    domain_name: string;
    type: AD_ENTITY_TYPES;
};
